// extracted by mini-css-extract-plugin
export var button = "styles-module--button--7141c";
export var container = "styles-module--container--61f2b";
export var highlightText = "styles-module--highlightText--0b8fb";
export var image = "styles-module--image--4e369";
export var imageBox = "styles-module--imageBox--5a6a2";
export var imageLeft = "styles-module--imageLeft--8290b";
export var imageRight = "styles-module--imageRight--c756e";
export var info = "styles-module--info--f6d9d";
export var parentContainer = "styles-module--parentContainer--1c91f";